import { get } from './';
export const getKinds = ({ locale } = {}) =>
  get(`/api/v1/kinds?locale=${encodeURIComponent(locale ?? 'en')}`);
